export default __webpack_public_path__ + "static/media/new-contact.4f2bd18d.svg";